import React, { Component } from "react";
import Ink from "react-ink";
import { withRouter } from "react-router-dom";


class WebShare extends Component {
  state = {
    shareButton: false,
  };
  componentDidMount() {
    if (navigator.share) {
      this.setState({ shareButton: true });
    }
  }

  shareLink = (link, title) => {
    console.log(link);
    if (navigator.share) {
      navigator
        .share({
          url: "https://elevateyoursport.com/public/product/" + link,
          text: title,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.shareButton && (
          <button
            type="button"
            className="btn search-navs-btns nav-home-btn"
            style={{
              position: "relative",
              maxWidth: "40px",
              fontSize: "1.5rem",
              padding: "9px",
            }}
            onClick={() => this.shareLink(this.props.link, this.props.title)}
          >
            {/* <i className="si si-share-alt" /> */}
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="share" class="svg-inline--fa fa-share " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-112 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"></path></svg>
            <Ink duration="500" />
          </button>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(WebShare);
